import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-entity',
  template: '<router-outlet></router-outlet>',
  styles: [':host { display: block; overflow-x: hidden; overflow-y: visible; height: 100%;}']
})
export class LayoutEntityComponent {
}
